import React from 'react';
import { Panel, PanelTheme } from '@apply/components';
import { TextBoxPanel } from './components/TextBoxPanel';
import { BankAccountBoxPanel } from './components/BankAccountBoxPanel';
import { EmailBoxPanel } from './components/EmailBoxPanel';
import { PasswordBoxPanel } from './components/PasswordBoxPanel';
import { PhoneBoxPanel } from './components/PhoneBoxPanel';
import { UrlBoxPanel } from './components/UrlBoxPanel';
import { ZipCodeBoxPanel } from './components/ZipCodeBoxPanel';
import { DemoSection } from '../common/SectionNavigator';
import { DemoPage, DemoPageSection } from '../common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'textBoxDemo_textbox', title: 'Text Box' },
    { id: 'textBoxDemo_bankaccountbox', title: 'Bank Account Box' },
    { id: 'textBoxDemo_emailbox', title: 'Email Box' },
    { id: 'textBoxDemo_passwordbox', title: 'Password Box' },
    { id: 'textBoxDemo_phonebox', title: 'Phone Box' },
    { id: 'textBoxDemo_urlbox', title: 'Url Box' },
    { id: 'textBoxDemo_zipcodebox', title: 'Zip Code Box' },
];

export const TextBoxDemo: React.FC = () => {
    return (
        <DemoPage
            title='Text Box :'
            sections={sections}
        >
            <DemoPageSection id={sections[0].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <TextBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[1].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <BankAccountBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[2].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <EmailBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[3].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <PasswordBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[4].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <PhoneBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[5].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <UrlBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[6].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <ZipCodeBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
